import { ContentType } from 'services/data-manager/types';

import { widthPercentageToDP } from 'utils/responsiveness';

import {
    CAST_ITEM_SIZE_WEB,
    CHANNEL_ITEM_SIZE_WEB,
    LANDSCAPE_ITEM_SIZE,
} from 'components/CustomButtons/RibbonTouchable/styles';

export function getRibbonCardWidth(metadataType: ContentType) {
    switch (metadataType) {
        case ContentType.CastPerson:
            return CAST_ITEM_SIZE_WEB;
        case ContentType.ChannelItem:
            return widthPercentageToDP(CHANNEL_ITEM_SIZE_WEB);
        default:
            return widthPercentageToDP(LANDSCAPE_ITEM_SIZE);
    }
}
